import { CreatePaymentRequestResp } from "@garther/interfaces";
import {
  useCreatePaymentRequestMutation,
  useUserCreditTransactions,
  useUserCredits
} from "@garther/query-hooks";
import { getErrorMessage, toast, useI18n } from "@garther/ui/libs";

export { creditKeys, useMyCreditQuery, useMyTransactionsQuery } from "@garther/query-hooks";

export function useOrgCreditQuery(orgId: string) {
  return useUserCredits(orgId);
}

export function useOrgCreditTransactionsQuery(orgId: string) {
  return useUserCreditTransactions(orgId);
}

export function useCreatePaymentRequest(
  options: { onSuccess?: (result: CreatePaymentRequestResp) => void } = {}
) {
  const { t } = useI18n();
  return useCreatePaymentRequestMutation({
    onSuccess: options.onSuccess,
    onError: (error) => toast.error(getErrorMessage(error) || t("common.error.tryAgain"))
  });
}
